export const file = {
    "file_Files": "文件列表",
    "file_ShareFiles": "分享给你的文件",
    "file_DeleteFiles": "已删除文件",
    "file_s'folder": "的文件夹",
    "file_s'_shareRoot": "的共享权限文件夹",
    "file_my_folder": "我的文件夹",
    "empty_file": "暂无文件",
    "file_table_col_Name": "文件名",
    "file_table_col_Size": "大小",
    "file_table_col_CreatedBy": "上传人",
    "file_table_col_CreateTime": "创建时间",
    "file_table_col_Reads": "查看数",
    "file_table_col_Option": "操作",
    "file_table_col_Option_Rename": "重命名",
    "file_table_col_Option_Move": "移动",
    "file_table_col_Option_Share": "分享",
    "file_table_col_Option_Auth_Share": "共享权限",
    "file_table_col_Option_Delete": "删除",
    "file_sort_click_sort_by": "点击排序方式...",
    "file_sort_by_name": "按名称排序",
    "file_sort_by_size": "按大小排序",
    "file_sort_by_type": "按类型排序",
    "file_admin_btn_create": "创建文件夹",
    "file_admin_btn_add": "上传文件",
    "file_admin_btn_add_multi": "批量上传文件",
    "file_view_list": "列表模式",
    "file_view_cards": "卡片模式",
    "file_share_modal_title": "查看本页分享文件 ({{count}} 个分享)",
    "file_share_modal_list": "列表",
    "file_share_modal_cards": "卡片",
    "file_share_modal_close": "关闭",
    "file_share_modal_selected": "已选择 {{count}} 项",
    "file_share_modal_batch_delete": "批量删除",
    "file_share_modal_no_shares": "本页没有分享的文件",
    "file_share_modal_share_user": "Share User",
    "file_share_modal_share_group": "Share Group",
    "file_share_modal_share": "Share",
    "file_share_modal_time": "Time",
    "file_share_modal_no_expiration": "No Expiration",
    "file_share_modal_expires": "Expires",
    "file_share_modal_remark": "Remark",
    "file_share_modal_share_by": "Share By",
    "file_share_modal_delete": "删除",
    "file_share_modal_shares_count": "{{count}} 个分享",
    "file_share_modal_type_user": "用户",
    "file_share_modal_type_group": "组",
    "file_share_modal_type_password": "密码",
    "file_share_modal_password_share": "密码分享",
    "file_share_modal_time_range": "时间区间",
    "file_share_modal_expiry_time": "过期时间",
    "file_share_modal_never_expires": "永不过期",
    "file_share_modal_sharer": "分享者",
    "file_share_modal_fetch_error": "获取分享信息失败",
    "file_share_modal_delete_success": "删除分享成功",
    "file_share_modal_delete_error": "删除分享失败",
    "file_share_modal_batch_delete_success": "成功删除 {{count}} 个分享",
    "file_share_modal_batch_delete_error": "{{count}} 个分享删除失败",
    "file_share_create_modal_title": "文件分享设置：",
    "file_share_create_modal_batch_title": "批量分享设置 ({{count}} 个文件)",
    "file_share_create_modal_file_list": "文件清单",
    "file_share_create_modal_create_new": "Create New Share",
    "file_share_create_modal_share_type": "Share Type",
    "file_share_create_modal_user": "User",
    "file_share_create_modal_group": "Group",
    "file_share_create_modal_expiry_time": "Expiry Time",
    "file_share_create_modal_custom_expiry": "Custom Expiry",
    "file_share_create_modal_start_date": "Start Date",
    "file_share_create_modal_end_date": "End Date",
    "file_share_create_modal_remark": "Remark",
    "file_share_create_modal_remark_placeholder": "Enter remark",
    "file_share_create_modal_create_share": "Create Share",
    "file_share_create_modal_current_shares": "Current Shares",
    "file_share_create_modal_custom_time_error": "自定义时间需要选择时间",
    "file_share_create_modal_share_exists": "该用户或组已存在相同类型的分享",
    "file_share_create_modal_create_success": "分享创建成功",
    "file_share_create_modal_batch_success": "成功分享 {{count}} 个文件",
    "file_share_create_modal_share_failed": "分享失败",
    "file_share_create_modal_expiry_no_expiration": "永不过期",
    "file_share_create_modal_expiry_custom": "自定义",
    "file_share_create_modal_expiry_6_hours": "6小时",
    "file_share_create_modal_expiry_1_day": "1天",
    "file_share_create_modal_expiry_3_days": "3天",
    "file_share_create_modal_expiry_7_days": "7天",
    "file_share_create_modal_expiry_14_days": "14天",
    "file_share_create_modal_expiry_21_days": "21天",
    "file_share_create_modal_expiry_1_month": "1个月",
    "file_share_create_modal_expiry_3_months": "3个月",
    "file_share_create_modal_expiry_6_months": "6个月",
    "file_share_create_modal_expiry_1_year": "1年",

    "file_player_back": "← 返回文件列表",
    "file_player_loading": "正在加载文件…",
    "file_player_loading_title": "正在加载预览…",
    "file_player_loading_progress": "加载中 {{loaded}}/{{total}}",
    "file_player_progress_file_label": "文件",
    "file_player_progress_resource_label": "播放器资源",
    "file_player_progress_detail": "{{loaded}}/{{total}} · {{percent}}%",
    "file_player_progress_preparing": "准备中…",
    "file_player_progress_waiting": "等待中…",
    "file_player_unauthorized": "无权查看此文件",
    "file_player_load_failed": "文件加载失败",
    "file_player_unsupported": "暂不支持此文件类型的预览",

    "file_ppt_anim_hint": "放映模式已自动开启。用鼠标单击逐步播放动画；GIF 在放映模式下播放。若与 PowerPoint 仍有差异，属 OnlyOffice 兼容性限制。",
    "file_player_initial_loading": "加载中…",

    "file_pdf_mode_single": "单页",
    "file_pdf_mode_multi": "平铺",
    "file_pdf_mode_play": "放映",
    "file_pdf_zoom": "缩放",
    "file_pdf_zoom_fit": "最佳",
    "file_pdf_zoom_custom": "自定义",
    "file_pdf_zoom_custom_aria": "自定义缩放百分比",
    "file_pdf_prev": "上一页",
    "file_pdf_next": "下一页",
    "file_pdf_page_aria": "页码",
    "file_pdf_exit_play": "退出放映",
    "file_pdf_play_hint": "点击左右半屏翻页 · 方向键 / 空格 · Esc 退出全屏放映",
    "file_pdf_loading": "正在加载 PDF…",
    "file_pdf_load_error": "PDF 加载失败",
    "file_pdf_cannot_load": "无法加载 PDF",
    "file_pdf_multi_hint": "共 {{count}} 页 · 方向键可同步页码",
};

export const fileAuthShareModal = {
    files_AuthShareModal_title: "文件共享权限路径：",
    files_AuthShareModal_alert_message: "共享分享权限给其他的学术老师，其他学术老师将对该文件夹及子文件夹可见，分享前请注意检查是否分享正确",
    files_AuthShareModal_unauthorized_teachers: "未授权老师",
    files_AuthShareModal_authorized_teachers: "已授权老师",
    files_AuthShareModal_operation_grant: "授权",
    files_AuthShareModal_operation_revoke: "取消",
    files_AuthShareModal_search_placeholder: "搜索老师",
    files_AuthShareModal_success_grant: "已授权 {{count}} 位老师",
    files_AuthShareModal_success_revoke: "已取消 {{count}} 位老师的权限",
    files_AuthShareModal_error_load: "加载权限数据失败",
    files_AuthShareModal_error_operation: "操作失败，请重试",
};
